'use strict';

// ProjectOffice workspace — an office/location that owns users (User.IDProjectOffice). Overview + a Users childlist.
// (Project has no IDProjectOffice, so there is no Projects childlist.)
module.exports = {
	Identifier: 'ProjectOfficeWorkspace', Ordinal: 256,
	Entity: { Name: 'ProjectOffice', IDField: 'IDProjectOffice', Collection: 'ProjectOffices', GUIDField: 'GUIDProjectOffice' },
	Header: { Eyebrow: 'Project Office', Title: (r) => r.Name || `Project Office ${r.IDProjectOffice}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/ProjectOffice/List' },
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'users', Label: 'Users', Icon: 'fas fa-users', Content: { kind: 'childlist', ref: 'User', parentField: 'IDProjectOffice',
			columns: [ { Key: 'NameFirst', Label: 'First' }, { Key: 'NameLast', Label: 'Last' }, { Key: 'Email', Label: 'Email' } ], empty: 'No users in this office.' } },
	],
	FieldGroups:
	[
		{ Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'OfficeCode', Label: 'Office Code', Mono: true } ] },
		{ Name: 'Location', Fields: [ { Key: 'Address', Label: 'Address', Wide: true }, { Key: 'City', Label: 'City' }, { Key: 'State', Label: 'State' }, { Key: 'Zip', Label: 'Zip' }, { Key: 'Phone', Label: 'Phone' } ] },
	],
};
